module.exports = __webpack_public_path__ + "static/media/cardboard-services.151c8f53.jpg";